import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Field, Form, FormikProvider, useFormik } from "formik";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";
import Swal from "sweetalert2";
import CommonReactTable from "../CommonUtils/CommonReactTable";
import { failureAlert } from "../CommonUtils/SweetAlerts";
import CommonFormHeading from "../CommonUtils/CommonFormHeading";


export default function AfflTeachingSubAdd() {
    const [data, setData] = useState([]);
    const [course, setCourse] = useState([]);
    const [repData, setRepData] = useState([]);
    const [spec, setSpec] = useState([]);
    const [checkedRows, setCheckedRows] = useState({});
    const formik = useFormik({
        initialValues: {
            employeeSubDetails: []
        },

        onSubmit: (values) => {
            const payload = data?.map((dd, i) => ({
                empId: dd?.emp_id,
                courseGroupCode: formik?.values?.employeeSubDetails[i]?.courseGroupCode,
                subjectCode: formik?.values?.employeeSubDetails[i]?.specializationCode,
                notTeachingMajorSubject: formik?.values?.employeeSubDetails[i]?.other || '',
            })).filter(row => row.courseGroupCode);

            const isCheckboxSelected = formik?.values?.employeeSubDetails.some((details, i) => details?.check);
            if (!isCheckboxSelected) {
                Swal.fire({
                    icon: 'error',
                    text: 'Please select at least one Employee.',
                    backdrop: false
                });
                return;
            }

            const invalidEmployeeIndexes = formik?.values?.employeeSubDetails
                .map((details, i) => details?.check && !details?.specializationCode ? i + 1 : -1)
                .filter(i => i !== -1);  // Filter out invalid indexes (-1)

            if (invalidEmployeeIndexes.length > 0) {
                Swal.fire({
                    icon: 'error',
                    text: `Please select course and subject for the selected employees at Row(s) ${invalidEmployeeIndexes.join(', ')}.`,
                    backdrop: false
                });
                return;
            }

            let isValidationFailed = false;  // Flag to track validation failure
            for (let i = 0; i < payload.length; i++) {
                const item = payload[i];
                if (item.subjectCode === '9999' && (!item.notTeachingMajorSubject)) {
                    Swal.fire({
                        icon: 'error',
                        text: `Subject is required for the employee at Row ${i + 1} .`,
                        backdrop: false
                    });
                    isValidationFailed = true;
                    break;
                }
            }

            if (isValidationFailed) {
                return;  // Prevent further execution if validation fails
            }

            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.API_URL + `updateEmployeeSubjects`;
                    CommonAxiosPost(url, payload).then((res) => {
                        if (res?.data?.scode === '01') {
                            Swal.fire(res?.data?.sdesc, '', 'success').then((response) => {
                                if (response?.isConfirmed) {
                                    window.location.reload();
                                }
                            });
                        } else {
                            failureAlert("Failed to submit")

                        }
                    });
                }
            });

        }


    });


    const handleCheckboxChange = (index) => {
        setCheckedRows((prevCheckedRows) => ({
            ...prevCheckedRows,
            [index]: !prevCheckedRows[index],
        }));

        if (checkedRows[index]) {
            formik.setFieldValue(`employeeSubDetails[${index}].courseGroupCode`, '');
            formik.setFieldValue(`employeeSubDetails[${index}].specializationCode`, '');
            formik.setFieldValue(`employeeSubDetails[${index}].other`, '');
        }
    }
    const Columns = [
        { Header: "Sl.no", accessor: (row, index) => index + 1, },
        {
            Header: "Name of the Employee", accessor: "emp_name",
            Cell: ({ row }) => <div className="text-left">{row?.values?.emp_name ? row?.values?.emp_name : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: <>Date of Birth<br />/Gender</>, accessor: "dob",
            Cell: ({ row }) => <div className="text-left">{row?.original?.dob}<br />({row?.original?.gender})</div>
        },
        {
            Header: "Aadhar", accessor: "aadhar",
            Cell: ({ row }) => <div>{row?.values?.aadhar ? row?.values?.aadhar : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: <>Employee type<br />/ Designation type</>, accessor: "emp_type_name",
            Cell: ({ row }) => <div>{row?.values?.emp_type_name ? row?.values?.emp_type_name : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Designation", accessor: "designation_name",
            Cell: ({ row }) => <div>{row?.values?.designation_name ? row?.values?.designation_name : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: <>Course that he <br />/ she is teaching</>, accessor: "course_cat_name",
            Cell: ({ row }) => <div className="text-left">{row?.values?.course_cat_name ? row?.values?.course_cat_name : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Subject", accessor: "course_name",
            Cell: ({ row }) => <div className="text-left">{row?.values?.course_name ? row?.values?.course_name : <b style={{ textAlign: 'left' }}>-</b>}</div>
        },
    ]

    function GetData() {
        try {
            let url = `${config.url.API_URL}getEmpSub`;
            CommonAxiosGet(url,).then((res) => {
                if (res?.data?.scode === '01') {
                    setData(res?.data?.EmpSub);
                } else {
                    setData([]);
                }
            });
        } catch (error) {
            console.error('Error fetching employee subjects:', error);
            setData([]);
        }

        try {
            let qualUrl = `${config.url.API_URL}getCourses`;
            CommonAxiosGet(qualUrl,).then((res) => {
                if (res?.data?.scode === '01') {
                    setCourse(res?.data?.Courses);
                } else {
                    setCourse([]);
                }
            });
        } catch (error) {
            console.error('Error fetching courses:', error);
            setCourse([]);
        }

        try {
            let urlll = `${config.url.API_URL}getEmpSubReport`;
            CommonAxiosGet(urlll,).then((res) => {
                if (res?.data?.scode === '01') {
                    setRepData(res?.data?.EmpSubReport);
                } else {
                    setRepData([]);
                }
            });
        } catch (error) {
            console.error('Error fetching employee subject report:', error);
            setRepData([]);
        }
    }


    function GetSpecializations(courseCatId, index) {
        let url = config.url.API_URL + `getSpecilization/${courseCatId}`;
        CommonAxiosGet(url,).then((res) => {
            if (res?.data?.scode === '01') {
                setSpec(prevSpecs => {
                    const updatedSpecs = [...prevSpecs];
                    updatedSpecs[index] = res?.data?.Specilization;
                    return updatedSpecs;
                });
            } else {
                setSpec(prevSpecs => {
                    const updatedSpecs = [...prevSpecs];
                    updatedSpecs[index] = [];
                    return updatedSpecs;
                });
            }
        });
    }

    const handleCheck = (index) => {
        if (!checkedRows.includes(index)) {
            setCheckedRows((prevCheckedRows) => [...prevCheckedRows, index]);
        } else {
            setCheckedRows((prevCheckedRows) => prevCheckedRows.filter((row) => row !== index));
            formik.setFieldValue(`employeeSubDetails[${index}].courseGroupCode`, '');
            formik.setFieldValue(`employeeSubDetails[${index}].specializationCode`, '');
            formik.setFieldValue(`employeeSubDetails[${index}].other`, '');
        }
    }

    useEffect(() => {
        GetData();
    }, []);

    return (
        <>
            <div className="affl-newdiv2">
                <CommonFormHeading heading={"Teaching Staff Add Subject"} />


                <Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">

                    <FormikProvider value={formik}>
                        <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit} className="form_adjust">
                            {data && data.length > 0 ? (<>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1 className="">Teaching Staff Details</h1>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-sm affl-table">
                                        <thead>
                                            <tr>
                                                <th>SNO </th>
                                                <th>Name of the Employee</th>
                                                <th>Date of Birth/Gender</th>
                                                <th>Aadhar</th>
                                                <th>Employee type/Designation type</th>
                                                <th>Designation</th>
                                                <th>Course that he/she is teaching</th>
                                                <th>Subject</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data && data.map((dd, i) => (
                                                <tr key={i}>
                                                    <td>
                                                        <Field
                                                            type="checkbox"
                                                            checked={checkedRows[i] || false}
                                                            onChange={() => { handleCheckboxChange(i); handleCheck(i) }}
                                                            className='mx-1'
                                                            name={`employeeSubDetails[${i}].check`}

                                                        />
                                                        {i + 1}</td>
                                                    <td className="text-left">{dd?.emp_name || '-'}</td>
                                                    <td className="text-left">{dd?.dob} ({dd?.gender})</td>
                                                    <td style={{ width: '100px' }}>{dd?.aadhar}</td>
                                                    <td>{dd?.emp_type_name || '-'}</td>
                                                    <td>{dd?.designation_name || '-'}</td>
                                                    <td>
                                                        <Field
                                                            as='select'
                                                            className='form-control form-control-sm'
                                                            name={`employeeSubDetails[${i}].courseGroupCode`}
                                                            onChange={(e) => GetSpecializations(e.target.value, i)}
                                                            disabled={!checkedRows[i]}
                                                        >
                                                            <option value=''>--SELECT--</option>
                                                            {course && course.map((course, idx) => (
                                                                <option key={idx} value={course?.course_cat_id}>{course?.course_cat_name}</option>
                                                            ))}
                                                        </Field>
                                                    </td>
                                                    <td>
                                                        <Field
                                                            as="select"
                                                            className="form-control form-control-sm"
                                                            name={`employeeSubDetails[${i}].specializationCode`}
                                                            disabled={!checkedRows[i]}
                                                        >
                                                            <option value=''>--SELECT--</option>
                                                            {spec[i] && spec[i].map((sp, idx) => (
                                                                <option key={idx} value={sp?.course_id}>{sp?.course_name}</option>
                                                            ))}
                                                            {spec[i] && <option value='9999'>Not teaching single major subject</option>}
                                                        </Field> <br />
                                                        {formik?.values?.employeeSubDetails[i]?.specializationCode === '9999' &&
                                                            <Field type='text' className='form-control form-control-sm' name={`employeeSubDetails[${i}].other`} maxLength={80} disabled={!checkedRows[i]} />}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <button type='submit' className='btn btn-success btn-sm float-end'>Submit</button>
                            </>) : null}
                        </Form>
                    </FormikProvider>
                    {repData.length > 0 ? (<>
                        <div className="inner-herbpage-service-title-sub mt-5">
                            <h1 className="">Teaching Staff Add Subject  Report</h1>
                        </div>
                        <div className="table-responsive">
                            <CommonReactTable data={repData} columns={Columns} filename="Teaching Staff Add Subject " headerName={`Teaching Staff Add Subject`} />
                        </div>
                    </>) : null}
                </Container>
            </div>
        </>
    );
}
